import React from 'react';

import { TSvgIcon } from '../types';

export const PhoneIcon: TSvgIcon = ({ color = 'white', width = 18, height = 18 }): JSX.Element => {
    return (
        <svg width={width} height={height} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M16.2291 12.26L13.6891 11.97C13.0791 11.9 12.4791 12.11 12.0491 12.54L10.2091 14.38C7.37906 12.94 5.05906 10.63 3.61906 7.79001L5.46906 5.94001C5.89906 5.51001 6.10906 4.91001 6.03906 4.30001L5.74906 1.78001C5.62906 0.77001 4.77906 0.0100098 3.75906 0.0100098H2.02906C0.899064 0.0100098 -0.0409359 0.95001 0.0290641 2.08001C0.559064 10.62 7.38906 17.44 15.9191 17.97C17.0491 18.04 17.9891 17.1 17.9891 15.97V14.24C17.9991 13.23 17.2391 12.38 16.2291 12.26Z"
                fill={color}
            />
        </svg>
    );
};
